export const MARKET_INSIGHTS_AGREEMENT_KEY = 'market_insights_agreement';
export const PORTAL_SIDEBAR_KEY = 'portal_sidebar_viewed';
export const SEARCH_BAR_TOOLTIP_KEY = 'search_bar_tooltip_view';
export const SIXTY_SECONDS = 1000 * 60;
export const ONE_YEAR = 1000 * 60 * 60 * 24 * 365;

// Default ttl of 60 seconds
const setItemWithExpiry = (key, value, ttl = SIXTY_SECONDS) => {
    const now = new Date();
    const item = {
        value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

// Get item and auto-delete if expired
const getItem = (key, skipRemoval = false) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (!skipRemoval) {
        localStorage.removeItem(key); // Always remove item after retrieval
    }
    return item.value;
}

const forceClearItem = (key) => {
    localStorage.removeItem(key);
}

const clearItemWithExpiry = () => {
    const now = new Date().getTime();

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;

        try {
            const itemStr = localStorage.getItem(key);
            const item = JSON.parse(itemStr);

            // Check if the item has an expiry and if it's expired
            if (item && item.expiry && now > item.expiry) {
                localStorage.removeItem(key);
                console.log(`Removed expired item: ${key}`);
            }
        } catch (error) {
            // Ignore non-JSON or other unexpected items
            console.warn(`Skipping item: ${key}`, error);
        }
    }
}

export default {
    setItemWithExpiry,
    getItem,
    clearItemWithExpiry,
    forceClearItem,
};
